import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { CardBackgroundComponent } from '../../card-background.component';
import { GenericPostCardStackBackgroundViewModel } from './generic-post-card-stack-background-view-model';
import type { GenericCardData } from '../../../../../../../models/print-cards/generic-card-data';

@Component({
  selector: 'app-generic-post-card-stack-background',
  templateUrl: './generic-post-card-stack-background.component.html',
  styleUrls: ['./generic-post-card-stack-background.component.scss'],
  providers: [GenericPostCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GenericPostCardStackBackgroundComponent extends CardBackgroundComponent implements AfterViewInit {
  constructor(
    public viewModel: GenericPostCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: GenericCardData;
}
